export enum DwellingInspectionDocumentConnectionKind {
  General = 0,
}

export enum ActionsTaken {
  SelectLater = 0,
  ErrandForLandlord = 1,
  HandledByTenant = 2,
  ErrandForLandlordAndHandledByTenant = 3,
  ForDocumentation = 4
}

export enum DwellingInspectionDeviationStatus {
  All = 0,
  Noted = 1,
  Active = 2,
  Closed = 3,
  NeedsErrand = 4
}

export enum AssignedResponsibility {
  None = 0,
  Landlord = 1,
  Tenant = 2,
}

export function DwellingInspectionDocumentConnectionKindToString(documentType: DwellingInspectionDocumentConnectionKind): string {
  switch (documentType) {
    case DwellingInspectionDocumentConnectionKind.General:
      return 'DWELLING_INSPECTION.DOCUMENT_CONNECTION_KIND.GENERAL';
    default:
      throw new Error('Unknown DwellingInspectionDocumentConnectionKind.');
  }
}

export function DwellingInspectionDeviationStatusToString(
  status: DwellingInspectionDeviationStatus
): string {
  switch (status) {
    case DwellingInspectionDeviationStatus.All:
      return 'DWELLING_INSPECTION_DEVIATION.STATUSES.ALL';
    case DwellingInspectionDeviationStatus.Noted:
      return 'DWELLING_INSPECTION_DEVIATION.STATUSES.NOTED';
    case DwellingInspectionDeviationStatus.Active:
      return 'DWELLING_INSPECTION_DEVIATION.STATUSES.ACTIVE';
    case DwellingInspectionDeviationStatus.Closed:
      return 'DWELLING_INSPECTION_DEVIATION.STATUSES.CLOSED';
    case DwellingInspectionDeviationStatus.NeedsErrand:
      return 'DWELLING_INSPECTION_DEVIATION.STATUSES.NEEDS_ERRAND';
    default:
      throw new Error('Unknown DwellingInspectionDeviationStatus.');
  }
}

export function AssignedResponsibilityToString(
  responsibility: AssignedResponsibility
): string {
  switch (responsibility) {
    case AssignedResponsibility.None:
      return 'DWELLING_INSPECTION_DEVIATION.ASSIGNMENTS.NONE';
    case AssignedResponsibility.Landlord:
      return 'DWELLING_INSPECTION_DEVIATION.ASSIGNMENTS.LANDLORD';
    case AssignedResponsibility.Tenant:
      return 'DWELLING_INSPECTION_DEVIATION.ASSIGNMENTS.TENANT';
    default:
      throw new Error('Unknown AssignedResponsibility.');
  }
}
